import { render } from "./SongReportsList.vue?vue&type=template&id=4542bf1a&scoped=true"
import script from "./SongReportsList.vue?vue&type=script&lang=js"
export * from "./SongReportsList.vue?vue&type=script&lang=js"

import "./SongReportsList.vue?vue&type=style&index=0&id=4542bf1a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4542bf1a"]])

export default __exports__